import { useCallback, useRef } from 'react';
import { useFlowServices } from './flow-service.hooks';

const useApplicationSettings = (
  showApplicationSettings: () => Promise<boolean>
): ((forceShow?: boolean) => Promise<boolean>) => {
  const { flow, flowService } = useFlowServices();
  const isShowingRef = useRef<boolean>(false);

  const showSettings = useCallback(
    async (forceShow?: boolean): Promise<boolean> => {
      if (!isShowingRef.current) {
        isShowingRef.current = true;

        let result = false;
        if (flow) {
          const valid = await flowService.isFlowValidForTeaching(flow);
          if (!valid || forceShow) {
            result = await showApplicationSettings();
          } else {
            result = true;
          }
        }

        isShowingRef.current = false;

        return result;
      }

      return false;
    },
    [flow, flowService, showApplicationSettings]
  );

  return showSettings;
};

export { useApplicationSettings };
